/* eslint-disable react/jsx-props-no-spreading */
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { memo, useCallback } from "react";
import { debounce } from "lodash";
import CustomErrorText from "../CustomErrorText";

interface Props {
  options: string[];
  onChange: (e: string) => void;
  className?: string;
  touched?: boolean;
  error?: string;
  loadingText?: string;
  setFieldValue: (field: string, value: string) => void;
  setFieldTouched: (field: string, value: boolean) => void;
  name: string;
  value: string;
  label: string;
  filterOptions?: any;
  getOptionLabel?: any;
}
function CustomAutocomplete({
  options,
  onChange,
  className,
  setFieldTouched,
  touched,
  error,
  loadingText,
  setFieldValue,
  value: formValue,
  name,
  label,
  filterOptions,
  getOptionLabel
}: Props) {
  const handleThrottle = useCallback(
    debounce((_event: any, inputValue: any) => onChange(inputValue), 400),
    []
  );
  return (
    <div className={className}>
      <Autocomplete
        freeSolo
        value={formValue}
        options={options}
        classes={{
          root: "!bg-white",
          paper: "!mt-1",
          loading: "!text-sm !font-montserrat"
        }}
        loading={options.length === 0}
        loadingText={loadingText}
        onChange={(_event, value: any) => setFieldValue(name, value)}
        onInputChange={handleThrottle}
        onBlur={(event: any) => {
          setFieldTouched(name, true);
          if (!options.includes(event.target.value)) setFieldValue(name, "");
        }}
        {...(filterOptions
          ? {
              filterOptions,
              getOptionLabel
            }
          : {})}
        selectOnFocus
        // eslint-disable-next-line react/jsx-props-no-spreading
        renderInput={(params) => (
          <div className="rounded-lg bg-white border border-solid border-discoBall focus-within:border-2 focus-within:border-hotShot">
            <TextField
              {...params}
              required
              variant="filled"
              label={label}
              InputProps={{
                ...params.InputProps,
                classes: {
                  input:
                    "!text-sm !leading-5 !font-medium !text-black !bg-white !rounded-lg !font-montserrat",
                  root: `!rounded-lg !bg-white`,
                  disabled: "!bg-gray-200"
                },
                disableUnderline: true
              }}
              InputLabelProps={{
                ...params.InputLabelProps,
                classes: {
                  root: "!text-sm !leading-5 !font-medium !text-platinumGranite !font-montserrat !pt-0.5 !pb-2",
                  shrink: "!text-purpleComet !text-xs"
                }
              }}
            />
          </div>
        )}
      />
      {touched && error && <CustomErrorText text={error} type="error" />}
    </div>
  );
}

CustomAutocomplete.defaultProps = {
  className: "",
  touched: false,
  error: "",
  loadingText: "Please Search...",
  filterOptions: undefined,
  getOptionLabel: undefined
};

export default memo(CustomAutocomplete);
